export default "__VITE_ASSET__CjHSztUM__"